import React from 'react';
import {Row} from "react-bootstrap";
import {HomeArticleItem} from "./HomeArticleItem";
import {ArticleDiv, StyledArticleContainer, HomeSectionTitle, HomeSectionType} from "../../utils/common-styles";

export const HomeArticleContent = (props) => {

    return (
        <ArticleDiv>
            <StyledArticleContainer>
                <HomeSectionTitle><strong>Our most recent articles ____</strong></HomeSectionTitle>
                <HomeSectionType><h2>From the Wood</h2></HomeSectionType>
            <Row>
                {props.posts.length > 0 && props.posts.map((article) => <HomeArticleItem key={article.id} article={article} />)}
            </Row>
        </StyledArticleContainer>
        </ArticleDiv>
    )
}
